module.exports = __webpack_public_path__ + "images/coachnow_pro_logo.82e22b3c024b3c293b28f69cd0fab26e.svg";